import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ThemeGalleryApi from "../api/themeGallery-api";
import { IThemeGalleryReq, IThemeGalleryRes } from "../types";
import { RootState } from "../app/store";


const initialState: {
    loading: boolean;
    error: string | null;
    data: IThemeGalleryRes | null;
} = {
    loading: false,
    error: null,
    data: null,
};

export const themeGallery = createAsyncThunk<IThemeGalleryRes, IThemeGalleryReq>(
    "themeGallery",
    async (request: IThemeGalleryReq, thunkApi) => {
        try {
            const response = await ThemeGalleryApi.themeGallery(request);
            return thunkApi.fulfillWithValue(response);
        } catch (error: any) {
            return thunkApi.rejectWithValue(error.message || "An error occurred");
        }
    }
)

const themeGallerySlice = createSlice({
    name: "themeGallery",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(themeGallery.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(themeGallery.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(themeGallery.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload as string;
        });
    }
})

export default themeGallerySlice.reducer;
export const themeGalleryLoading = (state: RootState) => state.themeGallery.loading;
